'use-client';
import React from 'react';
import classNames from 'clsx';
import type { MediaContainerVideoAPI } from '@wix/editor-elements-types/components';
import {
  getDataAttributes,
  getAriaAttributes,
} from '@wix/editor-elements-common-utils';
import { useVideoAPI } from '@wix/editor-elements-common-utils/hooks';
import MeshContainer from '@wix/thunderbolt-elements/src/thunderbolt-core-components/MeshContainer/viewer/MeshContainer';
import FillLayers from '@wix/thunderbolt-elements/src/components/FillLayers/viewer/FillLayers';
import type { SlideShowSlideProps } from '../SlideShowSlide.types';
import styles from './style/SlideShowSlide.scss';

const SlideShowSlide: React.ForwardRefRenderFunction<
  MediaContainerVideoAPI,
  SlideShowSlideProps
> = (props, compRef) => {
  const {
    id,
    className,
    fillLayers,
    children,
    skin,
    meshProps,
    onMouseEnter,
    onMouseLeave,
    getPlaceholder,
    onStop,
    a11y,
  } = props;

  const a11yAttributes = getAriaAttributes({
    ...a11y,
  });

  const MeshContainerWithChildren = (
    <MeshContainer id={id} {...meshProps}>
      {children}
    </MeshContainer>
  );

  const hasVideo = !!fillLayers.video;
  const videoRef = useVideoAPI(compRef, hasVideo, onStop);

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(className, styles.SlideShowSlide)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...a11yAttributes}
    >
      <FillLayers
        {...fillLayers}
        extraClass={styles.bg}
        getPlaceholder={getPlaceholder}
        videoRef={videoRef}
      />
      <div className={styles.borderNode} />
      {skin === 'StateBoxStateFormSkin' ? (
        <form
          onSubmit={e => {
            e.preventDefault();
          }}
        >
          {MeshContainerWithChildren}
        </form>
      ) : (
        MeshContainerWithChildren
      )}
    </div>
  );
};

export default React.forwardRef(SlideShowSlide);
